export default {
  SET_LOGIN_DATA_MIDW_AUTH(state, payload) {
    state.displayNameMiddlewareAuth = payload.displayName;
    state.userIdMiddlewareAuth = payload.userId;
    state.emailMiddlewareAuth = payload.email;
    state.trustPCMiddlewareAuth=payload.trustPC
  },
  SET_FULL_LOGIN_DATA_MIDW_AUTH(state, payload) {
    state.displayNameMiddlewareAuth = payload.displayName;
    state.userIdMiddlewareAuth = payload.userId;
    state.emailMiddlewareAuth = payload.email;
    state.tokenMiddlewareAuth = payload.token;
    state.autologoutMiddlewareAuth = payload.autologout
    state.trustPCMiddlewareAuth=payload.trustPC
  },
  SET_TOKEN_MIDW_AUTH(state, payload) {
    state.tokenMiddlewareAuth = payload.token;
    state.autologoutMiddlewareAuth = payload.autologout
  },
  RESET_LOGIN_DATA_MIDW_AUTH(state) {
    state.displayNameMiddlewareAuth = ''
    state.userIdMiddlewareAuth = null
    state.emailMiddlewareAuth = null
    state.tokenMiddlewareAuth = null
    state.autologoutMiddlewareAuth = false
    state.trustPCMiddlewareAuth=false
  },
  SET_AUTOLOGOUT_MIDW_AUTH(state, value) {
    state.autologoutMiddlewareAuth = value
  },
  SET_BASIC_USER_DATA_MIDW_AUTH(state, newUserData) {
    state.basicUserDataMiddlewareAuth = newUserData
  },
	SET_USER_NAME_MIDW_AUTH(state, newUserData) {
    state.userNameMiddlewareAuth = newUserData
  },
}
